import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4fb33120"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component--footer py-2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "my-5" }
const _hoisted_4 = {
  "footer--text": "",
  style: {"color":"white"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "font-weight-regular",
  style: {"color":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" Need Ethereum wallet? Get one from "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-white",
    href: "https://www.myetherwallet.com/wallet/create",
    target: "_blank",
    style: {"text-decoration":"none"}
  }, " myetherwallet.com ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white font-weight-bold" }, "Get a wallet", -1))

import mewIconLight from "@/assets/images/icon-mew-logo-light.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const presentDate = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { class: "text-center" }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _unref(mewIconLight),
          alt: "MEW",
          height: "25"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, " ©" + _toDisplayString(_unref(presentDate)) + " MyEtherWallet Inc. All rights reserved ", 1),
          _hoisted_5
        ]),
        _createVNode(_component_v_btn, {
          size: "x-large",
          class: "rounded-pill text-white mt-3 text-none",
          color: "btn-get-wallet",
          href: "https://www.myetherwallet.com/wallet/create",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})